import { filter } from "../filter.js";
const typeFilter = documentType => {
  return filter.at("document.type", documentType);
};
export { typeFilter };
